new Vue({
  el: '#app',
  delimiters: ['[[', ']]'],
  data: {
    filters: {},
    preselected: {},
    selected: {},
    numbers: {
      guests: 0,
      adults: 0,
      children: 0,
      beds: 0,
      bedrooms: 0,
      bathrooms: 0,
      pets: 0
    },
    numbers_total: {
      guests: 0,
      adults: 0,
      children: 0,
      beds: 0,
      bedrooms: 0,
      bathrooms: 0,
      pets: 0
    },
    initial_products_ids: [],
    products_ids: [],
    marker_ids: [],
    backup_products_ids: [],
    bounds: null,
    sort: 'rank',
    limit: 9999,
    markers: [],
    search: '',
    type: 'X',
    ll: null
  },
  components: {
    item: {
      props: ['p'],
      data: function () {
        return {

        }
      },
      methods: {
        menter: function (id) {
          if (window.matchMedia('(min-width: 1200px)').matches) {
            this.$root.markers.forEach(function (m) {
              if (markerSlider) { markerSlider.destroy(); markerSlider = null }
              if (m.pid == id) {
                m.info.open(map, m);
              }
            })
          }
        },
        mleave: function () {
          if (window.matchMedia('(min-width: 1200px)').matches) {
            this.$root.markers.forEach(function (m) {
              m.info.close(map, m);
            })
          }
        }
      }
    }
  },
  watch: {
    selected: {
      deep: true,
      handler: function (filters) {
        var self = this, pros = []
        products.forEach(function (p) {
          var all_checked = true, single = true
          Object.keys(filters).forEach(function (filter) {
            if (isNaN(filters[filter]) && filters[filter].length) {
              var at_least_one = false
              filters[filter].forEach(function (filtr) {
                if (p.tags.indexOf(filter + '::' + filtr) > -1) {
                  if (filter.indexOf('OPTION_') > -1) {
                    var at_least_one_variant = false
                    p.variants.forEach(function (v) {
                      if (v.options.indexOf(filtr) > -1 && v.available) {
                        at_least_one_variant = true
                      }
                    })

                    if (at_least_one_variant) {
                      at_least_one = true
                    }
                  } else {
                    at_least_one = true
                  }
                }

              })
            } else {
              at_least_one = true

              all_zeros = true
              Object.keys(p.numbers).forEach(function (key) {
                if (p.numbers[key] > 0) {
                  all_zeros = false
                }
              })
              if (all_zeros) {
                single = false
              }
            }

            if (Number.isInteger(parseInt(filters[filter])) && single) {
              if (p.numbers[filter] >= filters[filter]) {
                at_least_one = true
              } else {
                at_least_one = false
              }
            }

            if (!at_least_one) {
              all_checked = false
            }
          })

          if (all_checked) {
            var allow = true
            if (self.search) {
              allow = false
              if (p.search.toLowerCase().indexOf(self.search.toLowerCase()) != -1 && p.type == self.type) {
                allow = true
              }
            }
            if (allow) {
              pros.push({
                id: p.id,
                sort: p.sort,
                html: p.html,
                latlong: p.latlong,
                info: p.info,
                url: p.url,
                search: p.search,
                type: p.type,
                numbers: p.numbers
              })
            }
          }
        })

        this.find(pros)
        this.limit = 24

      }
    },
    sort: function () {
      var arr = JSON.parse(JSON.stringify(this.products_ids))
      this.find(this.sorting(arr))
    },
    marker_ids: function () {
      var self = this
      this.markers.forEach(function (m) {
        m.setMap(null)
      })
      this.markers = []
      this.products_ids.forEach(function (el) {
        if (el.latlong) {
          var coo = el.latlong.split(',')
          marker = new google.maps.Marker({ position: { lat: parseFloat(coo[0]) - 0.00004, lng: parseFloat(coo[1]) }, map: map, icon: icon, title: el.title, pid: el.id, url: el.url, info: new google.maps.InfoWindow({ content: el.info }) })
          self.markers.push(marker)
          /*google.maps.event.addListener(marker, 'mouseover', function() {
            this['info'].open(map, this);
          });
          google.maps.event.addListener(marker, 'mouseout', function() {
            this['info'].close(map, this);
          });*/
          google.maps.event.addListener(marker, 'click', function () {
            var _this = this
            if (markerSlider) { markerSlider.destroy(); markerSlider = null }
            self.$root.markers.forEach(function (m) {
              m.info.close(map, m);
            })
            this['info'].open(map, this);
            setTimeout(function () {
              markerSlider = tns({
                container: document.querySelector('#marker-' + _this.pid + ' .slider')
              });
            }, 0)
          });
        }
      })

      var bounds = new google.maps.LatLngBounds(), i = 0
      while (i < self.markers.length) {
        bounds.extend(self.markers[i].getPosition())
        i++
      }
      var originalMaxZoom = map.maxZoom;
      map.setOptions({ maxZoom: 12 });
      map.fitBounds(bounds);
      setTimeout(function () { map.setOptions({ maxZoom: originalMaxZoom ? originalMaxZoom : 16 }); }, 100)
    }
  },
  methods: {
    find: function (pros) {
      var self = this, list = JSON.parse(JSON.stringify(pros ? pros : this.initial_products_ids))
      if (!pros) {
        list = list.filter(function (p) {
          return p.search.toLowerCase().indexOf(self.search.toLowerCase()) > -1 && p.type == self.type
        })
      }
      Vue.set(this, 'products_ids', list);
      Vue.set(this, 'marker_ids', list);
      Vue.set(this, 'backup_products_ids', list);
    },
    select: function (filter, filtr) {
      if (this.preselected[filter]) {
        if (this.preselected[filter].indexOf(filtr) == -1) {
          this.preselected[filter].push(filtr)
        } else {
          this.preselected[filter].splice(this.preselected[filter].indexOf(filtr), 1)
          if (!this.preselected[filter]) {
          }
        }
      } else {
        Vue.set(this.preselected, filter, [filtr])
      }
    },
    save: function () {
      var self = this
      this.selected = JSON.parse(JSON.stringify(this.preselected))
      var numbers = JSON.parse(JSON.stringify(this.numbers))
      Object.keys(numbers).forEach(function (key) {
        self.selected[key] = numbers[key]
      });

      setTimeout(function () {
        document.querySelector('body').classList.remove('underlay')
      }, 100);
    },
    sorting: function (arr) {
      if (this.sort == 'rank') {
        arr.sort(function (a, b) {
          r1 = a.sort.rank ? a.sort.rank : '999'
          r2 = b.sort.rank ? b.sort.rank : '999'
          return parseInt(r1) - parseInt(r2);
        });
      }
      else if (this.sort == 'price_asc') {
        arr.sort(function (a, b) {
          return a.sort.price - b.sort.price
        });
      }
      else if (this.sort == 'price_desc') {
        arr.sort(function (b, a) {
          return a.sort.price - b.sort.price
        });
      }
      else if (this.sort == 'az') {
        arr.sort(function (a, b) {
          return a.sort.title === b.sort.title ? 0 : a.sort.title < b.sort.title ? -1 : 1;
        });
      }
      else if (this.sort == 'za') {
        arr.sort(function (b, a) {
          return a.sort.title === b.sort.title ? 0 : a.sort.title < b.sort.title ? -1 : 1;
        });
      }
      else if (this.sort == 'date+asc') {
        arr.sort(function (a, b) {
          return new Date(a.sort.created_at) - new Date(b.sort.created_at);
        });
      }
      else if (this.sort == 'date_desc') {
        arr.sort(function (b, a) {
          return new Date(a.sort.created_at) - new Date(b.sort.created_at);
        });
      }
      return arr
    },
    counting: function (filter, filtr) {
      var self = this, counts = []

      products.forEach(function (p) {
        var allow = true
        if (self.search) {
          allow = false
          if (p.search.toLowerCase().indexOf(self.search.toLowerCase()) != -1 && p.type == self.type) {
            allow = true
          }
        }
        if (allow) {
          if (p.tags.indexOf(filter + '::' + filtr) > -1) {
            if (filter.indexOf('OPTION_') > -1) {
              var at_least_one_variant = false
              p.variants.forEach(function (v) {
                if (v.options.indexOf(filtr) > -1 && v.available) {
                  at_least_one_variant = true
                }
              })

              if (at_least_one_variant) {
                counts.push(p.id)
              }
            } else {
              counts.push(p.id)
            }
          }
        }
      })

      Object.keys(this.preselected).forEach(function (f) {
        if (f != filter) {
          products.forEach(function (p) {
            counts.forEach(function (c) {
              if (p.id == c) {
                if (self.preselected[f].length) {
                  var checks = false
                  self.preselected[f].forEach(function (f2) {
                    if (p.tags.indexOf(f + '::' + f2) > -1) {
                      checks = true
                    }
                  })
                  if (!checks) {
                    counts.splice(counts.indexOf(p.id), 1)
                  }
                }
              }
            })
          })
        }
      })

      return counts.length
    },

    showProductsInMap: function () {
      console.log("filtering items based on current map");
      var filteredList = [];
      var bounds = new google.maps.LatLngBounds(this.bounds);

      this.backup_products_ids.forEach(function (el) {
        if (el.latlong) {
          var coo = el.latlong.split(',')
          var lat = parseFloat(coo[0]);
          var lng = parseFloat(coo[1]);

          if (bounds.contains(new google.maps.LatLng(lat, lng))) {
            filteredList.push(el);
          }
        }
      });

      console.log(this.backup_products_ids);
      console.log(filteredList);

      Vue.set(this, 'products_ids', filteredList);
    }
  },
  mounted: function () {
    var self = this
    var filters = {}
    var pros = []

    if (products.length) {

      ColorScheme = [{ "featureType": "all", "elementType": "labels.text", "stylers": [{ "color": "#878787" }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "off" }] }, { "featureType": "landscape", "elementType": "all", "stylers": [{ "color": "#f9f5ed" }] }, { "featureType": "road.highway", "elementType": "all", "stylers": [{ "color": "#f5f5f5" }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#c9c9c9" }] }, { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#aee0f4" }] }]

      mapOptions = {
        zoom: 10,
        scrollwheel: false,
        center: new google.maps.LatLng(40.730610, -73.935242),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: ColorScheme,
        gestureHandling: "greedy"
      };

      map = new google.maps.Map(document.getElementById('map'), mapOptions);

      var search = document.querySelector('.search-areas form');
      /*if (search) {
        search.addEventListener('submit', function(e) {
          e.preventDefault()
          self.search = e.target.querySelector('input').value
          self.find()

          var url = new URL(window.location);
          url.searchParams.set('q', self.search);
          url.searchParams.set('type', self.type);
          window.history.pushState(null, '', url.toString());
        })
      }*/

      var urlParams = new URLSearchParams(window.location.search);
      var q = urlParams.get('q');
      var t = urlParams.get('type');
      if (q) {
        this.search = q;
        search.querySelector('input').value = q;
        search.querySelector('.switcher').dataset.active = t;

        search.querySelectorAll('.switcher span').forEach(function (span) {
          span.addEventListener('click', function (e) {
            location.href = location.href.indexOf('type=H') > -1 ? location.href.replace('type=H', 'type=X') : location.href.replace('type=X', 'type=H')
          })
        })
      }
      if (t) {
        this.type = t;
      }

      products.forEach(function (p) {
        var allow = true
        if (q) {
          allow = false
          if (p.search.toLowerCase().indexOf(self.search.toLowerCase()) != -1 && p.type == self.type) {
            allow = true
          }
        }
        if (allow) {
          pros.push({
            id: p.id,
            sort: p.sort,
            html: p.html,
            latlong: p.latlong,
            info: p.info,
            url: p.url,
            search: p.search,
            type: p.type,
            numbers: p.numbers
          })
          Object.keys(p.numbers).forEach(function (key) {
            self.numbers_total[key] += p.numbers[key]
          })
          p.tags.forEach(function (t) {
            var vals = t.split('::')
            if (!filters[vals[0]]) {
              filters[vals[0]] = []
            }
            if (filters[vals[0]].indexOf(vals[1]) == -1) {
              filters[vals[0]].push(vals[1])
              filters[vals[0]].sort()
            }
          })
        }
      })

      this.find(this.sorting(pros))
      Vue.set(this, 'initial_products_ids', this.sorting(pros))

      if (q) {
        this.find()
      }

      Object.keys(filters).forEach(function (key) {
        sorted_filters[key] = filters[key]
      })

      Vue.set(this, 'filters', sorted_filters);
      var scrollPosition = 0;

      document.querySelectorAll('.dropdown button').forEach(function (e) {
        e.addEventListener('click', function (e) {
          if (e.target.parentElement.classList.contains('clicked')) {
            e.target.parentElement.classList.remove('clicked')
            //document.querySelector('body').classList.remove('underlay')
          } else {
            document.querySelectorAll('.dropdown button').forEach(function (e) {
              e.parentElement.classList.remove('clicked')
              //document.querySelector('body').classList.remove('underlay')
            })
            e.target.parentElement.classList.add('clicked')
            // scrollPosition = window.pageYOffset;
            // document.querySelector('body').style.top = -scrollPosition + 'px';
            document.querySelector('body').classList.add('underlay')
          }
        })
      })

      document.addEventListener('click', function (e) {
        if (!e.target.closest('.dropdown')) {
          if (document.querySelector('body').classList.contains('underlay')) {
            document.querySelectorAll('.dropdown button').forEach(function (e) {
              e.parentElement.classList.remove('clicked')
              document.querySelector('body').classList.remove('underlay')
              // window.scrollTo(0, scrollPosition);
            })
          }
        } else {
          if (e.target.classList.contains('bg')) {
            if (document.querySelector('body').classList.contains('underlay')) {
              document.querySelectorAll('.dropdown button').forEach(function (e) {
                e.parentElement.classList.remove('clicked')
                document.querySelector('body').classList.remove('underlay')
                // window.scrollTo(0, scrollPosition);
              })
            }
          }
        }
      })

      var self = this;

      google.maps.event.addListener(map, 'bounds_changed', function () {
        const bounds = map.getBounds();
        Vue.set(self, 'bounds', bounds);
        self.showProductsInMap();
      });

    } else {

      document.querySelector('#app').innerHTML = '<h3 class="text-center">You don\'t have any locations saved.</h3>'

    }

  }
})